<template>
  <div class="orders">
    <div class="row">
      <div class="col-sm-12">
        <b-card bg-variant="white">
          <LoadingSpinner v-if="isLoading" />
          <Alerts />
          <TrackingModal ref="trackingModal" :data="tracking" :orderType="orderType" v-if="tracking !== null" :key="tracking.id" @hide="onTrackingHide"></TrackingModal>
          <ShowOrder
            ref="viewOrderModal"
            :key="shown.id"
            :orderobj="shown"
            v-if="shown !== null"
            @hide="onShowOrderHide"
          ></ShowOrder>

            {{ /* table controllerscontrollers */ }}
            <div>
              <div class="form-group form-inline pull-left mb-2">
                <b-button href size="sm" @click="sync()" class="vgt-left-btn">
                  <i class="fa fa-refresh" aria-hidden="true"></i>
                </b-button>&nbsp;
                <b-btn class="datepicker-button vgt-left-btn" size="sm" @click="$refs.datePicker.toggleCalendar()">Date</b-btn>
                <DateRangePicker
                  ref="datePicker"
                  @selected="onVGTDateRangeSelected"
                  i18n="EN"
                  :captions="{
                          'title': 'Choose Dates',
                          'ok_button': 'Apply'
                      }"
                  :presetRanges="datePresetRanges"
                ></DateRangePicker>&nbsp;
                <b-input-group size="sm">
                  <div class="input-group-prepend">
                    <div class="input-group-text vgt-left-btn">Marketplace</div>
                  </div>
                  <b-form-select
                    v-model="serverParams.marketType"
                    :options="marketplaceOptions"
                    @change="onVGTMarketplaceChange"
                  ></b-form-select>
                </b-input-group>&nbsp;
                <b-input-group size="sm">
                  <div class="input-group-prepend">
                    <div class="input-group-text vgt-left-btn">User</div>
                  </div>
                  <b-form-select
                    v-model="serverParams.voided_by"
                    :options="userOptions"
                    @change="onVGTVoidedByChange"
                  ></b-form-select>
                </b-input-group>
              </div>

              <div class="form-group form-inline pull-right mb-2">
                <b-input-group>
                  <b-input class="table-search border-right-0 border" v-model="searchkw" size="sm" placeholder="Search" @keypress.enter="onTableSearch"/>
                  <b-input-group-append>
                    <b-button
                      variant="outline-error"
                      class="border-left-0 border"
                      @click="onVGTClearSearch"
                    >
                      <i :class="['fa', 'fa-times', {'opacity-0': !searchkw}]"></i>
                    </b-button>
                  </b-input-group-append>
                  <b-input-group-append>
                    <b-btn variant="success" @click="onTableSearch">
                      <i class="fa fa-search"></i>
                    </b-btn>
                  </b-input-group-append>
                </b-input-group>
                &nbsp;
                <b-dropdown id="dropdown-1" text="Edit Columns" class="vgt-right-btn" size="sm">
                  <b-dropdown-form style="padding-left: 0.5rem">
                    <b-form-checkbox-group v-model="selectedColumns">
                      <b-form-checkbox v-for="col in columnSelection" :key="col.field" :value="col.field">
                        {{ col.label }}
                      </b-form-checkbox>
                    </b-form-checkbox-group>
                    <b-dropdown-item-button @click="onVGTColumnSelect">
                      <b-button size="sm" block class="vgt-right-btn">Apply</b-button>
                    </b-dropdown-item-button>
                  </b-dropdown-form>
                </b-dropdown>
                &nbsp;
                <b-button size="sm" @click="exportOrders('csv')" class="vgt-right-btn">
                  Export Data
                  <span class="glyphicon glyphicon-download-alt"></span>
                </b-button>
              </div>
            </div>
            {{ /* table controllerscontrollers */ }}

            <div class="clearfix"></div>

            <b-row class="justify-content-end">
              <b-col sm="auto" style="z-index: 999;">
                <b-input-group class="mb-2">
                  <div class="db-help import">
                    <b-dropdown variant="link" toggle-class="text-decoration-none" dropup no-caret>
                      <template slot="button-content">
                        <b-img src="/images/icons/information.png" />
                      </template>
                      <b-dropdown-text class="mb-0 py-1 px-2" style="width: 304px">
                        <ul>
                          <li>Maximum selected records is {{ serverParams.perPage }}</li>
                          <li>Records selected has to be within the current table</li>
                        </ul>
                      </b-dropdown-text>
                    </b-dropdown>
                  </div>
                  <b-form-input
                    class="table-search border-right-0 border"
                    size="sm"
                    v-model="customRange"
                    placeholder="Custom Range (e.g. 1-5, 10)"
                    style="width: 200px;"
                    @keyup.enter="customSelectedRows"
                  />
                  <b-input-group-append>
                    <b-button
                      variant="outline-error"
                      class="border-left-0 border"
                      @click="(e) => {
                        if(customRange) {
                          customRange = '';
                        }
                      }"
                    >
                      <i :class="['fa', 'fa-times', {'opacity-0': !customRange}]"></i>
                    </b-button>
                  </b-input-group-append>
                  <b-input-group-append>
                    <b-btn variant="success" @click="customSelectedRows">Go</b-btn>
                  </b-input-group-append>
                </b-input-group>
              </b-col>
            </b-row>

            {{ /* VGT */ }}
            <vue-good-table
              ref="vgt"
              mode="remote"
              :columns="columns"
              :rows="rows"
              styleClass="vgt-table striped bordered condensed"
              max-height="70vh"
              :select-options="{ enabled: true, selectOnCheckboxOnly: true, selectionText: selected_text, clearSelectionText: 'Unselect All', selectionInfoClass: selection_class }"
              :search-options="{ enabled: true, externalQuery: searchTerm }"
              :pagination-options="{ enabled: true, mode: 'records', rowsPerPageLabel: 'Records per page', perPage: serverParams.perPage, perPageDropdown: [50, 100, 250], dropdownAllowAll: false }"
              :totalRows="totalRecords"
              :line-numbers="true"
              @on-search="onVGTSearch"
              @on-selected-rows-change="onVGTSelected"
              @on-row-dblclick="onVGTDoubleClick"
              @on-page-change="onVGTPageChange"
              @on-sort-change="onVGTSortChange"
              @on-column-filter="onVGTColumnFilter"
              @on-per-page-change="onVGTPerPageChange"
            >
              <div slot="emptystate"> N/A </div>
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field === 'id'" class="d-flex justify-content-center">
                  <button class="btn btn-primary btn-xs view mr-1" @click="showOrder(props.row.id)">View</button>
                  <!-- <button class="btn btn-primary btn-sm" @click="e => trackRefund(props.row.id)">Status</button> -->
                  <button class="btn btn-primary btn-xs" @click="e => copyOrder(props.row.id)">Copy</button>
                </span>
                <span v-else-if="props.column.field === 'marketplace' ">
                  <img
                    v-if="props.row.marketplace"
                    :src="props.row.marketplace.img"
                    :height="props.row.marketplace.height"
                    :width="props.row.marketplace.weight"
                    class="img-responsive"
                  />
                  <span v-else>.</span>
                </span>
                <span v-else-if="props.column.field === 'address'">
                  {{ props.row.address.address1}} <br />
                  {{ props.row.address.address2}} <br />
                  {{ props.row.address.address3}}
                </span>
                <span v-else-if="props.column.field === 'status'">
                  {{ $t(props.row.status)}}
                </span>
                <span v-else-if="props.column.field === 'name'">
                  <span v-if="props.row.name.name.trim()">
                    {{ props.row.name.name }} <br />
                  </span>
                  {{ props.row.name.company }}
                </span>
                <span v-else-if="props.column.field === 'confirmation'">
                    {{ getSignatureName(props.row) }}
                </span>
                <span v-else-if="props.column.field === 'tracking_id'">
                  <!-- <a :href="props.row.tracking_id.target" target="_blank" >{{ props.row.tracking_id.id }}</a> -->
                  <a href="javascript:void(0);" :id="`popover-${props.row.tracking_id.id}`">{{ props.row.tracking_id.id }}</a>
                  <b-popover :target="`popover-${props.row.tracking_id.id}`" triggers="click blur" placement="right">
                    <b-row class="flex-column">
                      <b-col>
                        <a :href="props.row.tracking_id.target" target="_blank" >Open Link</a>
                      </b-col>
                      <b-col>
                        <a href="javascript:void(0);" @click="copyTrackingID(props.row.tracking_id.id)" >Copy</a>
                      </b-col>
                    </b-row>
                  </b-popover>
                </span>
                <span v-else-if="['created_at'].includes(props.column.field)">
                  {{ props.row[props.column.field]|readableDate }}
                </span>
                <span v-else-if="['postmark_date'].includes(props.column.field)">
                  <div v-if="props.row.postmark_date">
                    {{ props.row.postmark_date|utcDate("MMM DD YYYY") }}
                  </div>
                  <div v-else>
                    {{ props.row.created_at|utcDate("MMM DD YYYY") }}
                  </div>
                </span>
                <span v-else-if="props.column.field === 'product_sku'">
                  {{ props.row.product_sku|truncate(75) }}
                </span>
                <span v-else-if="['declared_value', 'rate', 'insurance_price','total_price', 'tracking_price', 'surcharge'].includes(props.column.field)">
                  {{ format.price(props.row[props.column.field]) }}
                </span>
                <span v-else-if="props.column.field === 'total_weight'">
                  {{getWeight(props.row.total_weight).lb}}lb
                  {{getWeight(props.row.total_weight).oz}}oz
                </span>

                <span v-else>
                  {{props.formattedRow[props.column.field]}}
                </span>
              </template>

            </vue-good-table>
            {{ /* VGT */ }}
        </b-card>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.btn {
  padding: 1px 8px !important;
}
input.search {
  height: 25px;
}
.datepicker-button {
  &:after {
    display: inline-block;
    width: 0;
    height: 0;
    margin-left: 0.255em;
    vertical-align: 0.255em;
    content: "";
    border-top: 0.3em solid;
    border-right: 0.3em solid transparent;
    border-bottom: 0;
    border-left: 0.3em solid transparent;
  }

  & + .calendar-root {
    .input-date {
      display: none;
    }
    .calendar {
      left: 0px;
      top: 35px;
      height: auto;
      min-height: 300px;
    }
  }
}
.orders-table {
  tbody {
    td {
      text-align: center !important;
    }
  }
  tfoot {
    background-color: rgba(#1e88e5, 0.1);
  }
}
</style>

<script>
import LoadingSpinner from "../../components/LoadingSpinner";
import Alerts from "../../components/Alerts";
import DateRangePicker from "vue-rangedate-picker";
import ShowOrder from "./ShowShippedInModal";
import TrackingModal from "../../components/TrackingModal";
import moment from "moment";
import Cookies from 'js-cookie';
import hash from 'object-hash';
import { VueGoodTable } from 'vue-good-table';
import VGTMixin from './Mixins/VGTMixins';
import lStore from './Mixins/lStore';

export default {
  components: {
    VueGoodTable,
    LoadingSpinner,
    Alerts,
    ShowOrder,
    TrackingModal,
    DateRangePicker
  },
  mixins: [VGTMixin],
  data(){
    return {
      tracking: null,
      columns: [
        {
          field: 'id', label: "Actions",
          thClass:"vgt-headers narrower",
          sortable: false,
        },
        {
          field: 'marketplace', label: "Marketplace",
          thClass:"vgt-headers narrowest",
        },
        {
          field: 'voided_by', label: "Voided By",
          thClass:"vgt-headers narrower", hidden: true,
        },
        {
          field: 'status', label : "Refund Status",
          thClass:"vgt-headers narrow",
        },
        {
          field: 'origin_address', label: "Origin Address",
          thClass:"vgt-headers wider", hidden: true,
        },
        {
          field: 'origin_postal', label: "Origin Postal",
          thClass:"vgt-headers narrow", hidden: true,
        },
        {
          field: 'order_number', label: "Order Number",
          sortable: true, thClass:"vgt-headers narrow", hidden: true,
        },
        {
          field: 'ref_id', label: "Reference ID",
          sortable: false, thClass:"vgt-headers narrow", hidden: true,
        },
        {
          field: 'created_at', label: "Voided Date", type: 'date',
          dateInputFormat: 'yyyy-M-dd HH:mm:ss', 'dateOutputFormat': 'MMM dd yyyy HH:mma',
          thClass:"vgt-headers wide",
        },
        {
          field: 'name', label: "Recipient",
          thClass:"vgt-headers",
        },
        {
          field: 'address', label: "Address",
          thClass:"vgt-headers widest",
          hidden: true,
        },
        {
          field: 'tracking_id', label: "Tracking Number",
          sortable: false,
          thClass:"vgt-headers",
        },
        {
          field: 'shipping_service', label: "Service Class",
          sortable: false,
          thClass:"vgt-headers",
        },
        {
          field: 'package_type', label: "Package Type",
          sortable: false,
          thClass:"vgt-headers",
        },
        {
          field: 'total_weight', label: "Weight",
          sortable: false,
          thClass:"vgt-headers narrower",
        },
        {
          field: 'declared_value', label: "Declared Value",
          sortable: false, hidden: true,
          thClass:"vgt-headers narrow",
        },
        {
          field: 'insurance_price', label: "Insurance",
          sortable: false, hidden: true,
          thClass:"vgt-headers narrow",
        },
        {
          field: 'rate', label: "Shipping Rate",
          sortable: false, hidden: true,
          thClass:"vgt-headers narrower",
        },
        {
          field: 'surcharge', label: "Surcharge",
          sortable: false,
          thClass:"vgt-headers narrower",
        },
        {
          field: 'total_price', label: "Total Cost",
          sortable: false, thClass:"vgt-headers narrow",
        },
        {
          field: 'confirmation', label: "Signature",
          sortable: false, hidden: true,
          thClass:"vgt-headers narrowest",
        },
        {
          field: 'dimension', label: "Dimensions",
          sortable: false, hidden: true,
          thClass:"vgt-headers narrower",
        },
        {
          field: 'tracking_price', label: "Additional Tracking",
          sortable: false, hidden: true,
          thClass:"vgt-headers",
        },
        {
          field: 'product_sku', label: "Product SKU",
          sortable: true, hidden: true,
          thClass:"vgt-headers",
        },
        {
          field: 'label_sticky', label: "Custom Field 1",
          sortable: true, hidden: true, thClass:"vgt-headers",
        },
        {
          field: 'label_sticky_2', label: "Custom Field 2",
          sortable: true, hidden: true, thClass:"vgt-headers",
        },
        {
          field: 'email', label: "Email",
          hidden: true, thClass:"vgt-headers",
        },
        {
          field: 'phone', label: "Phone",
          sortable: false, hidden: true,
          thClass:"vgt-headers",
        },
        {
          field: 'postmark_date', label: "Postmark Date",type: 'date',
          dateInputFormat: 'yyyy-M-dd', 'dateOutputFormat': 'MMM dd yyyy',
          sortable: false, thClass:"vgt-headers",
        },{
          field: 'description', label: "Description",
          sortable: false, hidden: true,
          thClass:"vgt-headers widest",
        },{
          field: 'acct_id', label: "Account ID",
          sortable: true, hidden: true,
          thClass:"vgt-headers",
        },{
          field: 'delivery_zone', label: "Delivery Zone",
          sortable: true, hidden: true,
          thClass:"vgt-headers narrow",
        },{
          field: 'extra_1', label: "Note 1",
          sortable: true, hidden: true,
          thClass:"vgt-headers",
        },{
          field: 'extra_2', label: "Note 2",
          sortable: true, hidden: true,
          thClass:"vgt-headers",
        },{
          field: 'extra_3', label: "Note 3",
          sortable: true, hidden: true,
          thClass:"vgt-headers",
        },{
          field: 'extra_4', label: "Note 4",
          sortable: true, hidden: true,
          thClass:"vgt-headers",
        },{
          field: 'extra_5', label: "Note 5",
          sortable: true, hidden: true,
          thClass:"vgt-headers",
        }
      ],
    }
  },
  async mounted() {
    // clear session every page visit then fetch new data
    this.orderType = {
      id: 4,
      name: 'voided',
    };
    // get saved in localstorage
    console.log('orderType', this.orderType);
    const cols = lStore.get(`${this.orderType.name}Columns`);
    if(cols){
      const { columns, selectedColumns } = cols;
      this.columns = columns;
      this.selectedColumns = selectedColumns;
    }
    const pP = lStore.get(`${this.orderType.name}PerPage`);
    if(pP){
      this.serverParams.perPage = pP;
    }

    await this.getUserPrintedBy()

    // await this.sync();
    await this.clearSessionAndFetch(this.orderType.name);
  },
  methods: {
    // trackRefund(orderId) {
    //   this.isLoading = true;
    //   axios
    //     .get(`orders/${orderId}/refund/track`)
    //     .then(response => {
    //       switch (response.data.refund_status) {
    //         case "requested":
    //           this.$toastr.i(
    //             "Refund request pending. Please check again later."
    //           );
    //           break;
    //         case "accepted":
    //           this.$toastr.s(
    //             "Your postage balance has been credited.",
    //             "Refund approved!"
    //           );
    //           break;
    //         case "denied":
    //           this.$toastr.e(
    //             response.data.refund_refusal_reason,
    //             "Refund denied!"
    //           );
    //           break;
    //       }
    //     })
    //     .catch(error => {
    //       this.$emit("alert", {
    //         message:
    //           "Failed to track refund. Please try again or contact our support team.",
    //         type: "danger"
    //       });
    //     })
    //     .finally(() => {
    //       this.isLoading = false;
    //       this.fetchOrders();
    //     });
    // },
    copyOrder(orderId) {
      this.$router.push(`/orders/new-shipment?id=${orderId}`);
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/views/Orders/Voided.vue